<template>
  <el-form
    :model="addForm"
    ref="addForm"
    label-width="120px"
    :hide-required-asterisk="false"
    class="form"
    :inline="true"
    id="add-program"
  >
    <el-row>
      <el-col :span="24">
        <el-form-item label="所属部门" prop="bmmc">
          <el-input
            v-model="addForm.bmmc"
            size="small"
            disabled="true"
            class="filter-item"
            style="width: 100px"
          />
        </el-form-item>
        <el-form-item label="项目名称" prop="xmbh">
          <el-select
            v-model="addForm.xmbh"
            filterable
            default-first-option
            class="filter-item"
            placeholder="请选择项目"
            @change="handleChengeXm"
          >
            <el-option
              v-for="item in xmList"
              :key="item.xmbh"
              :label="item.xmjc"
              :value="item.xmbh"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区域总监" prop="qyzj">
          <el-input
            v-model="addForm.qyzj"
            disabled="true"
            size="small"
            style="width: 100px"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-table
          :data="list"
          fit
          v-loading="loading"
          highlight-current-row
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
        >
          <el-table-column
            fixed
            label="操作"
            min-width="100px"
            align="center"
            class-name="small-padding fixed-width"
            :render-header="renderHeader"
          >
            <template slot-scope="scope">
              <!--<el-button-->
              <!--type="text"-->
              <!--@click="handleCopyRow(scope.row)"-->
              <!--size="mini"-->
              <!--&gt;复制</el-button-->
              <el-button
                type="text"
                @click="handleDelRow(scope.$index, list)"
                size="mini"
                >删除</el-button
              >
            </template>
          </el-table-column>

          <el-table-column
            label="节点名称"
            align="left"
            prop="name"
            min-width="200px"
          >
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.name"
                filterable
                :multiple="false"
                :collapse-tags="true"
                default-first-option
                style="width: 180px"
                class="filter-item"
                placeholder="请选择节点"
              >
                <el-option
                  v-for="item in jdNameList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column
            label="客户执行人"
            align="left"
            prop="customExecutor"
            min-width="250px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.customExecutor"
                filterable
                default-first-option
                :multiple="true"
                style="width: 210px"
                :collapse-tags="true"
                class="filter-item"
                placeholder="请选择节点"
              >
                <el-option
                  v-for="item in khexecutorList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column
            label="我方执行人"
            align="left"
            prop="companyExecutor"
            min-width="250px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <treeselect
                v-model="scope.row.companyExecutor"
                placeholder="请选择员工"
                :options="deptUser"
                :disable-branch-nodes="true"
                value-consists-of="LEAF_PRIORITY"
                no-results-text="未搜到任何结果"
                :clear-on-select="true"
                :normalizer="normalizer"
                min-width="235px"
                size="small"
                :multiple="true"
                appendToBody
                :limit="1"
                :default-expand-level="1"
              />
            </template>
          </el-table-column>

          <el-table-column
            label="完成时间"
            align="left"
            prop="completeTime"
            min-width="140px"
          >
            <template slot-scope="scope">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="scope.row.completeTime"
                style="width: 140px"
                :picker-options="pickerOptions"
                :clearable="false"
              >
              </el-date-picker>
            </template>
          </el-table-column>

          <el-table-column
            label="成果物"
            align="left"
            prop="cgw"
            min-width="400px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.cgw"
                filterable
                :multiple="true"
                style="width: 390px"
                :collapse-tags="true"
                default-first-option
                class="filter-item"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in cgwsList"
                  :key="item.id"
                  :label="item.file_name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { deepClone } from "@/utils/utils";
import moment from "moment";
import "moment/locale/zh-cn";
import { mapGetters } from "vuex";
import { getXmxxList } from "@/api/itWeekly";
import { getDsjXmxx, saveDsj, getDsjById } from "@/api/dsj.js";
export default {
  name: "Add",
  components: { Treeselect },
  props: ["mxParams"],
  computed: {
    ...mapGetters(["deptUser", "user"]),
  },
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      pickerOptions: {},
      list: [],
      loading: false,
      addForm: {
        xmbh: null,
        qyzj: null,
        bmmc: null,
      },
      jdNameList: [],
      cgwsList: [],
      khexecutorList: [],
      xmList: [],
      bmList: [],
      btnDisable: true,
      parentDialog: false,
    };
  },
  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    getXmxxList("DS", "1", "1", null, "").then((res) => {
      if (res.code == 0) {
        this.xmList = res.data;
      }
    });

    let id = this.mxParams.id;
    if (id != null) {
      //查询已经编辑好的
      getDsjById({ id: id }).then((res) => {
        if (res.code == 0) {
          this.addForm.bmmc = res.data.bmmc;
          this.addForm.qyzj = res.data.qyzj;
          this.addForm.xmbh = parseInt(res.data.xmbh);
          this.getDsjXmxxList(res.data.xmbh);
          this.list = res.data.list;
          for (let i = 0; i < this.list.length; i++) {
            this.list[i].name = this.list[i].jdbh;
            if (this.list[i].companyExecutor) {
              this.list[i].companyExecutor =
                this.list[i].companyExecutor.split(",");
            }
            this.list[i].completeTime = moment(this.list[i].completeTime);
            if (this.list[i].customExecutor) {
              this.list[i].customExecutor =
                this.list[i].customExecutor.split(",");
            }
            if (this.list[i].cgw) {
              this.list[i].cgw = this.list[i].cgw.split(",");
            }
          }
        }
      });
    }
  },
  mounted() {},
  methods: {
    handleChengeXm(e) {
      this.isHasProject();
    },
    getDsjXmxxList(xmbh) {
      getDsjXmxx({ xmbh: xmbh }).then((res) => {
        if (res.code == 0) {
          if (res.data != 0) {
            this.addForm.bmmc = res.data.bmmc;
            this.addForm.qyzj = res.data.qyzj;
            this.jdNameList = res.data.zjmxs;
            this.khexecutorList = res.data.khexecutor;
            this.cgwsList = res.data.cgws;
          }
        }
      });
    },
    isHasProject() {
      if (this.addForm.xmbh) {
        this.getDsjXmxxList(this.addForm.xmbh);
      }
    },
    handleCopyRow(row) {
      if (!row) {
        this.list.push({
          id: null,
          name: null,
          customExecutor: null,
          companyExecutor: null,
          completeTime: null,
          cgw: null,
        });
        return;
      }
      const newRow = deepClone(row);
      if (row.time && row.time.length > 0) {
        newRow.time = [
          moment(row.time[0]).format("YYYY-MM-DD"),
          moment(row.time[1]).format("YYYY-MM-DD"),
        ];
      }
      this.list.push(newRow);
    },

    handleDelRow(index, rows) {
      rows.splice(index, 1);
    },
    handleChangeModal(e) {
      if (!e) {
        //隐藏时触发
        let node = this.$refs["cascaderModal"].getCheckedNodes();

        if (node.length > 0) {
          //去重
          for (let i in node) {
            for (let j in this.list) {
              if (node[i].value == this.list[j].link_point) {
                node.splice(i, 1);
              }
            }
          }
        }
        if (node.length > 0) {
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
          }, 1000);
          //表格批量新增
          for (let i in node) {
            this.list.push({
              id: null,
              name: null,
              customExecutor: null,
              companyExecutor: null,
              completeTime: null,
              cgw: null,
            });
          }
        }
      }
    },
    handleInsert() {
      const list = deepClone(this.list);
      for (let i in list) {
        if (
          !(list[i].name && list[i].companyExecutor && list[i].completeTime)
        ) {
          this.$message.error("节点名称，我方执行人，完成时间为必填信息！");
          return;
        } else {
          list[i].id = this.list[i].id;
          list[i].xmbh = this.addForm.xmbh;
          list[i].cgw = this.list[i].cgw.join(",");
          list[i].companyExecutor = this.list[i].companyExecutor.join(",");
          list[i].customExecutor = this.list[i].customExecutor.join(",");
          list[i].completeTime = moment(this.list[i].completeTime).format(
            "YYYYMMDD"
          );
          Reflect.deleteProperty(list[i], "time");
        }
      }
      for (let i in list) {
        for (let j in list) {
          if (i !== j) {
            const isEqual = this.isObjectEqual(list[i], list[j]);
            if (isEqual) {
              this.$message.error("存在重复记录!");
              return;
            }
          }
        }
      }
      saveDsj(list).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.$emit("giveFather", this.parentDialog);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    isObjectEqual(obj1, obj2) {
      let o1 = obj1 instanceof Object;
      let o2 = obj2 instanceof Object;
      if (!o1 || !o2) {
        // 如果不是对象 直接判断数据是否相等
        return obj1 === obj2;
      }
      // 判断对象的可枚举属性组成的数组长度
      if (Object.keys(obj1).length !== Object.keys(obj2).length) {
        return false;
      }
      for (let attr in obj1) {
        let a1 =
          Object.prototype.toString.call(obj1[attr]) == "[object Object]";
        let a2 =
          Object.prototype.toString.call(obj2[attr]) == "[object Object]";
        let arr1 =
          Object.prototype.toString.call(obj1[attr]) == "[object Array]";
        if (a1 && a2) {
          // 如果是对象继续判断
          return isObjectEqual(obj1[attr], obj2[attr]);
        } else if (arr1) {
          // 如果是对象 判断
          if (obj1[attr].toString() != obj2[attr].toString()) {
            return false;
          }
        } else if (obj1[attr] !== obj2[attr]) {
          // 不是对象的就判断数值是否相等
          return false;
        }
      }
      return true;
    },
    renderHeader() {
      return (
        <el-button size="small" on-click={() => this.handleCopyRow(null)}>
          操作<span class="el-icon-plus"></span>
        </el-button>
      );
    },
  },
};
</script>
<style lang="less" scoped>
.form {
  padding: 15px;
}
</style>